import { jsx as l } from "react/jsx-runtime";
const i = ({ className: e, width: o = "24", height: a = "24" }) => /* @__PURE__ */ l(
  "svg",
  {
    className: e,
    width: o,
    height: a,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    children: /* @__PURE__ */ l(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m16.615 15.201 3.94 3.94a1 1 0 0 1-1.414 1.414l-3.94-3.94a7.5 7.5 0 1 1 1.414-1.414Zm-.463-4.55a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z",
        fill: "#969C9E"
      }
    )
  }
);
export {
  i as default
};
